/** Nom de marque affiché dans l'interface (nom propre : non traduit). */
export const BRAND_NAME = 'iCall CRM'
